import { useCallback } from 'react';
import { ChartType } from '..';
import './index.css';
import ColoredCheckbox from '../../../../../../components/ColoredCheckbox';
import { colors } from '../../../../../../colors';

interface Props {
  selectedChartTypes: ChartType[];
  setSelectedChartTypes: React.Dispatch<React.SetStateAction<ChartType[]>>;
  showAccumulativeData: boolean;
  setShowAccumulativeData: React.Dispatch<React.SetStateAction<boolean>>;
  totalBalanceColor: string;
  totalAssetBalanceColor: string;
  noAlgorithmicProgressionColors: string;
}

const ChartOptions: React.FC<Props> = (props: Props) => {
  const {
    selectedChartTypes,
    setSelectedChartTypes,
    showAccumulativeData,
    setShowAccumulativeData,
    totalBalanceColor,
    totalAssetBalanceColor,
    noAlgorithmicProgressionColors,
  } = props;

  const handleTogglePress = useCallback(
    (chartType: ChartType, value: boolean) => {
      if (value === true) {
        setSelectedChartTypes((prev) => [...prev, chartType]);
        return;
      }

      setSelectedChartTypes((prev) => {
        const updated = [...prev];

        if (updated.length === 1) {
          return updated;
        }

        updated.splice(
          prev.findIndex((c) => c === chartType),
          1,
        );

        return updated;
      });
    },
    [setSelectedChartTypes],
  );

  return (
    <div className="profit-chart-options-root">
      <div className="profit-chart-options-column">
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.TotalStableBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.TotalStableBalance, v)
            }
            color={totalBalanceColor}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.TotalStableBalance)
                ? totalBalanceColor
                : colors.white,
            }}
          >
            Total Stable Balance
          </span>
        </div>
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.TotalAssetBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.TotalAssetBalance, v)
            }
            color={totalAssetBalanceColor}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.TotalAssetBalance)
                ? totalAssetBalanceColor
                : colors.white,
            }}
          >
            Total Asset Balance
          </span>
        </div>
      </div>

      <div className="profit-chart-options-column">
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.StableBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.StableBalance, v)
            }
            color={totalBalanceColor}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.TotalStableBalance)
                ? totalBalanceColor
                : colors.white,
            }}
          >
            Stable Balance
          </span>
        </div>
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(ChartType.AssetBalance)}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.AssetBalance, v)
            }
            color={totalAssetBalanceColor}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: selectedChartTypes.includes(ChartType.AssetBalance)
                ? totalAssetBalanceColor
                : colors.white,
            }}
          >
            Asset Balance
          </span>
        </div>
      </div>

      <div className="profit-chart-options-column">
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={selectedChartTypes.includes(
              ChartType.NoAlgoritmicProgression,
            )}
            handleValueChange={(v) =>
              handleTogglePress(ChartType.NoAlgoritmicProgression, v)
            }
            color={colors.white}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: colors.white,
            }}
          >
            No Algorithm Progression
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChartOptions;
